import i18n from '../../../i18n'
import { documentDetailSearchFields, documentFields } from './fields'
import { documentDetailSearchFieldTypes, documentFieldTypes } from './fieldTypes'

export const documentsInputs = (isEdit, disableIdFields = false) => {
    const inputs = documentFieldTypes(disableIdFields)

    return {
        sideForm: [
            ...(isEdit ? [inputs[documentFields.FILE_DESCRIPTION]] : []),
            inputs[documentFields.DOCUMENT_PROPERTY_INTERNAL_APP_ID],
            inputs[documentFields.DOCUMENT_PROJECT_INTERNAL_APP_ID],
            inputs[documentFields.DOCUMENT_CONTACT_ID],
            inputs[documentFields.DOCUMENT_TYPE],
            inputs[documentFields.DOCUMENT_CREATION_DATE],
            inputs[documentFields.DOCUMENT_VALIDITY_DATE],
            inputs[documentFields.FILE_SYNC],
        ],
    }
}

export const documentsDetailSearchInputs = () => {
    const inputs = documentDetailSearchFieldTypes()

    return {
        mainForm: [
            inputs[documentDetailSearchFields.FILE_DESCRIPTION],
            inputs[documentDetailSearchFields.DOCUMENT_PROPERTY_ID],
            inputs[documentDetailSearchFields.DOCUMENT_PROJECT_ID],
            inputs[documentDetailSearchFields.DOCUMENT_CONTACT_ID],
            inputs[documentDetailSearchFields.DOCUMENT_TYPE],
            {
                type: 'array',
                name: 'creationDateGroup',
                children: {
                    type: 'grouped',
                    name: 'creationDateGrouped',
                    label: i18n.t('app.common.creationDate'),
                    colProps: { sm: 12 },
                    items: [
                        inputs[documentDetailSearchFields.DOCUMENT_CREATION_DATE_FROM],
                        inputs[documentDetailSearchFields.DOCUMENT_CREATION_DATE_TO],
                    ],
                },
            },
            {
                type: 'array',
                name: 'validityDateGroup',
                children: {
                    type: 'grouped',
                    name: 'validityDateGrouped',
                    label: i18n.t('app.common.expirationDate'),
                    colProps: { sm: 12 },
                    items: [
                        inputs[documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_FROM],
                        inputs[documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_TO],
                    ],
                },
            },
        ],
    }
}
